import { render } from "./elem-operating.vue?vue&type=template&id=2fdec771&ts=true"
import script from "./elem-operating.vue?vue&type=script&lang=ts"
export * from "./elem-operating.vue?vue&type=script&lang=ts"

import "./elem-operating.vue?vue&type=style&index=0&id=2fdec771&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__